import React from 'react';
import {
  Paper, Grid, FormControl, InputLabel, Select, MenuItem,
  Stack, Button, Chip, IconButton, Tooltip
} from '@mui/material';
import {
  Today as TodayIcon,
  CalendarToday as CalendarTodayIcon,
  DateRange as DateRangeIcon,
  ArrowBackIos as ArrowBackIosIcon,
  ArrowForwardIos as ArrowForwardIosIcon
} from '@mui/icons-material';

const EducationalScheduleFilters = ({
  selectedClass,
  setSelectedClass,
  selectedTeacher,
  setSelectedTeacher,
  dateFilter,
  setDateFilter,
  selectedDate,
  setSelectedDate,
  onDateChange,
  classList,
  staffList
}) => {
  const getDateDisplay = () => {
    if (dateFilter === 'today' || dateFilter === 'daily') {
      // Format as DD/MM/YYYY
      const day = String(selectedDate.getDate()).padStart(2, '0');
      const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
      const year = selectedDate.getFullYear();
      return `${day}/${month}/${year}`;
    } else if (dateFilter === 'monthly') {
      // Format as MM/YYYY
      const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
      const year = selectedDate.getFullYear();
      return `${month}/${year}`;
    }
    return 'الأسبوع الحالي';
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
      <Grid container spacing={2} alignItems="center">
        {/* Class Filter */}
        <Grid item xs={12} md={3}>
          <FormControl fullWidth>
            <InputLabel>الصف</InputLabel>
            <Select
              value={selectedClass}
              onChange={(e) => setSelectedClass(e.target.value)}
              label="الصف"
            >
              <MenuItem value="all">جميع الصفوف</MenuItem>
              {classList.map((cls) => (
                <MenuItem key={cls.id} value={cls.id}>
                  {cls.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Teacher Filter */}
        <Grid item xs={12} md={3}>
          <FormControl fullWidth>
            <InputLabel>المعلم</InputLabel>
            <Select
              value={selectedTeacher}
              onChange={(e) => setSelectedTeacher(e.target.value)}
              label="المعلم"
            >
              <MenuItem value="all">جميع المعلمين</MenuItem>
              {staffList.map((teacher) => (
                <MenuItem key={teacher.id} value={teacher.id}>
                  {teacher.first_name} {teacher.last_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Date Filter Type */}
        <Grid item xs={12} md={6}>
          <Stack useFlexGap direction="row" spacing={1} flexWrap="wrap" alignItems="center">
            <Chip
              icon={<CalendarTodayIcon />}
              label="أسبوعي"
              onClick={() => setDateFilter('weekly')}
              color={dateFilter === 'weekly' ? 'primary' : 'default'}
              variant={dateFilter === 'weekly' ? 'filled' : 'outlined'}
            />
            <Chip
              icon={<TodayIcon />}
              label="اليوم"
              onClick={() => setDateFilter('today')}
              color={dateFilter === 'today' ? 'primary' : 'default'}
              variant={dateFilter === 'today' ? 'filled' : 'outlined'}
            />
            <Chip
              label="أمس"
              onClick={() => setDateFilter('yesterday')}
              color={dateFilter === 'yesterday' ? 'primary' : 'default'}
              variant={dateFilter === 'yesterday' ? 'filled' : 'outlined'}
            />
            <Chip
              label="غداً"
              onClick={() => setDateFilter('tomorrow')}
              color={dateFilter === 'tomorrow' ? 'primary' : 'default'}
              variant={dateFilter === 'tomorrow' ? 'filled' : 'outlined'}
            />
            <Chip
              icon={<DateRangeIcon />}
              label="شهري"
              onClick={() => setDateFilter('monthly')}
              color={dateFilter === 'monthly' ? 'primary' : 'default'}
              variant={dateFilter === 'monthly' ? 'filled' : 'outlined'}
            />
          </Stack>
        </Grid>

        {/* Date Navigation (for daily/monthly) */}
        {(dateFilter === 'daily' || dateFilter === 'today' || dateFilter === 'monthly') && (
          <Grid item xs={12}>
            <Stack useFlexGap direction="row" spacing={2} alignItems="center" justifyContent="center">
              <IconButton onClick={() => onDateChange('prev')} size="small">
                <ArrowBackIosIcon />
              </IconButton>
              <Chip
                label={getDateDisplay()}
                sx={{ minWidth: 200, fontSize: '0.95rem' }}
              />
              <IconButton onClick={() => onDateChange('next')} size="small">
                <ArrowForwardIosIcon />
              </IconButton>
            </Stack>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default EducationalScheduleFilters;
